var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgListManagement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0.595536C0 0.266631 0.266631 0 0.595536 0H13.3003C13.6292 0 13.8958 0.266631 13.8958 0.595536C13.8958 0.924442 13.6292 1.19107 13.3003 1.19107H0.595536C0.266631 1.19107 0 0.924442 0 0.595536ZM0 10.7693C0 10.4404 0.266631 10.1737 0.595536 10.1737H11.8615L10.627 11.3648H0.595536C0.266631 11.3648 0 11.0982 0 10.7693ZM1.54839 2.54344C0.693238 2.54344 0 3.23667 0 4.09183V7.26802C0 8.12315 0.69323 8.81642 1.54839 8.81642H12.3475C13.2026 8.81642 13.8958 8.12316 13.8958 7.26802V4.09183C13.8958 3.23667 13.2026 2.54344 12.3475 2.54344H1.54839ZM1.19107 4.09183C1.19107 3.89448 1.35105 3.73451 1.54839 3.73451H12.3475C12.5448 3.73451 12.7048 3.89449 12.7048 4.09183V7.26802C12.7048 7.46535 12.5448 7.62535 12.3475 7.62535H1.54839C1.35106 7.62535 1.19107 7.46536 1.19107 7.26802V4.09183ZM0 13.3065C0 12.9776 0.266631 12.711 0.595536 12.711H8.2184C8.54731 12.711 8.81394 12.9776 8.81394 13.3065C8.81394 13.6354 8.54731 13.9021 8.2184 13.9021H0.595536C0.266631 13.9021 0 13.6354 0 13.3065Z",
    fill: "#0B0A0A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9722 10.8899L13.1016 14.8948C12.6803 15.3207 10.5722 16.2358 10.2662 15.9532C9.96008 15.6706 10.8937 13.5341 11.315 13.1082L15.3225 9.25791C15.5404 9.05013 15.8308 8.93587 16.1316 8.93954C16.4325 8.94321 16.7199 9.06453 16.9327 9.27757C17.1454 9.4906 17.2666 9.77849 17.2703 10.0798C17.274 10.381 17.1598 10.6718 16.9523 10.8899H16.9722Z",
    stroke: "#0B0A0A",
    strokeWidth: 0.952858,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListManagement);
export default __webpack_public_path__ + "static/media/list-management.b335fe0202c8db0b563f44f241f1408d.svg";
export { ForwardRef as ReactComponent };